// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"485":"fb70de99","698":"8e5768e9"}[chunkId] + ".chunk.js";
};